export function highlightText(
  text: string,
  term: string,
  wrapperTag: string
): string {
  return text.replace(
    new RegExp(`(${term})`, "ig"),
    `<${wrapperTag}>$1</${wrapperTag}>`
  )
}
